import { useNavigate } from "react-router-dom";
import MentalWellbeingQuestionnaireContent from "./MentalWellbeingQuestionnaireContent";

export default function MentalWellbeingQuestionnaire() {
  const navigate = useNavigate();

  return (
    <MentalWellbeingQuestionnaireContent
      onClose={() => navigate(-1)}
      onSubmitComplete={() => navigate(-1)}
    />
  );
}
